export default "__VITE_ASSET__JbsZUkuZ__"